import { Node } from "#/decision_tree_viewer/models/node";

export class SendToPortalNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "SendToPortalNode",
    };
  }
}
